import { createApi } from '@reduxjs/toolkit/query/react'
import resolveUploadUrl, { isAbsoluteUploadUrl } from '../../helpers/resolve-upload-url'
import getCustomFetchBase from '../custom-fetch-base'
import UploadedFile from '../../types/api/uploaded-file'

export const uploadApi = createApi({
    reducerPath: 'uploadApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Upload'],
    endpoints: builder => ({
        upload: builder.mutation<UploadedFile[], FormData>({
            query: formData => ({ url: '/upload', method: 'POST', body: formData }),
        }),
        downloadUploadedFile: builder.query<Blob, string>({
            async queryFn(uploadPath, _api, _extraOptions, baseQuery) {
                const url = resolveUploadUrl(uploadPath)

                // Файл на бэкенде (/uploads/...) — с авторизацией, как остальные запросы к API.
                if (!isAbsoluteUploadUrl(uploadPath)) {
                    const result = await baseQuery({
                        url,
                        responseHandler: resp => (resp.status === 200 ? resp.blob() : resp.json()),
                    })
                    return result.error ? { error: result.error } : { data: result.data as Blob }
                }

                // Файл во внешнем хранилище (S3) — без токена и cookies: они не нужны публичному
                // бакету и не должны уходить на сторонний домен.
                try {
                    const resp = await fetch(url, { credentials: 'omit' })
                    if (!resp.ok) {
                        return { error: { status: resp.status, data: await resp.text() } }
                    }
                    return { data: await resp.blob() }
                } catch (error) {
                    return { error: { status: 'FETCH_ERROR', error: String(error) } }
                }
            },
            keepUnusedDataFor: 0,
        }),
    }),
})

export const { useUploadMutation, useLazyDownloadUploadedFileQuery } = uploadApi
